<script>

export default {
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 24,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 24,
    },
    viewBox: {
      type: String,
      required: false,
      default: "0 0 24 24",
    },
    fillColor: {
      type: String,
      required: false,
      default: "fill-primary-500",
    },
    strokeColor: {
      type: String,
      required: false,
      default: "stroke-transparent",
    },
  }
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :class="`${fillColor} fill-current ${strokeColor}`"
  >
    <slot></slot>
  </svg>
</template>
